import _defineProperty from "/builds/telematics/zuul/web/prebooking-ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var _identifierMap;

var EXTRA_IDENTIFIERS = {
  SHIELD: 'shield',
  SHIELD_PLUS: 'shield-plus',
  COFFEE: 'coffee',
  ARROWS: 'arrows',
  ADDITIONAL_DRIVER: 'additional-driver'
};
var identifierMap = (_identifierMap = {}, _defineProperty(_identifierMap, EXTRA_IDENTIFIERS.SHIELD, 'basic_insurance'), _defineProperty(_identifierMap, EXTRA_IDENTIFIERS.SHIELD_PLUS, 'plus_insurance'), _defineProperty(_identifierMap, EXTRA_IDENTIFIERS.COFFEE, 'comfort_package'), _defineProperty(_identifierMap, EXTRA_IDENTIFIERS.ARROWS, 'cross_border'), _defineProperty(_identifierMap, EXTRA_IDENTIFIERS.ADDITIONAL_DRIVER, 'additional_driver'), _identifierMap); // map identifiers to readable names for Google Analytics

export var extraIdentifierToReadable = function extraIdentifierToReadable(identifier) {
  return identifierMap[identifier] || identifier;
};